export const createPolyline = (
  map: naver.maps.Map,
  strokeColor: string,
  path: naver.maps.LatLng[]
) => {
  return new naver.maps.Polyline({
    map,
    path: path,
    strokeColor: strokeColor,
    strokeWeight: 7,
  });
};
